import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { InstallationFeaturesStore } from '@store';
import {
  DeviceIds,
  Feature,
  FeatureNames,
  IsActiveProperty,
  RoomsChannelsEcoControlCommands,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-obng-src-settings-pump-control',
  templateUrl: './obng-src-settings-pump-control.component.html',
  styleUrls: ['./obng-src-settings-pump-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObngSrcSettingsPumpControlComponent {
  @Input({ required: true }) ecoControl: Feature<IsActiveProperty, RoomsChannelsEcoControlCommands>;
  @Input({ required: true }) circuitId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  onToggleChange(toggle: MatSlideToggle): void {
    const channelId = this.ecoControl.feature.split('.')[2];

    this.installationFeaturesStore.updateFeature(
      FeatureNames.roomsChannelsEcoControl(channelId),
      toggle.checked,
      'active',
      'active',
      'setActive',
      this.ecoControl.gatewayId,
      DeviceIds.RoomControl
    );
  }
}
